// extracted by mini-css-extract-plugin
export default {"message":"FoundationBlock_message__tvHrh","text-header":"FoundationBlock_text-header__EEJrD","image-partners":"FoundationBlock_image-partners__y9YRj"};